import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS} from './_base';

import I_ORGANISATIONS_SET from '../interfaces/I_ORGANISATIONS';
import {
  getOrganisationsResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- ORGANISATIONS
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {

}
/**
 * Récupère la liste des organisations avec controle d'acces
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,dispatch,state}:I_GET_PARAMS):Promise<I_ORGANISATIONS_SET[]> => {
  logger.debug('ApiServices - getOrganisations - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getOrganisationsResponse({accessToken:usedAccessToken});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getOrganisations - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_ORGANISATIONS_SET[] = await response.json();
  logger.debug('ApiServices - getOrganisations - ok, returned body',body);
  return body;
};



const ooodaysServices = {
  getList,
};

export default ooodaysServices;
